module.exports = __webpack_public_path__ + "img/d9e749d843cc9b2ac3d7861288d9c748.png";